<div
  class="flex justify-center items-center text-white pt-12 px-6 text-xs"
  [class]="isMobile() ? 'pb-6' : 'pb-4'"
>
  <mat-icon
    class="mr-2"
    matPrefix
  >copyright</mat-icon>
  {{ year }} A-V Services, Inc. All Rights Reserved.
</div>
